import React, { Component } from "react";
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';

const styles = theme => ({
  root: {
    width: '100%',
    marginBottom: 10
  },
  formControl: {
    flex: '1 100%'
  },
  select: {
    justifyContent: 'flex-end'
  },
  expansionTitle: {
    fontWeight: '500'
  }
});

class PackBuilderOptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: null,
    };
  }

  handleChange = panel => (expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  handleSelectChange = (options, optionName, optionType) => (event) => {
    const option = this.findOption(options, optionName)

    if(event.target.value !== '') {
      this.changeOption(option, optionType, event.target.value)
    } else {
      console.log("REMOVE ME NOW!")
    }
  }

  changeOption = (option, optionType, selectedValue) => {
      const optionPayload = {
        id: option.id,
        name: option.name,
        selectedValue: option.selections[selectedValue]
      }
      
      if(optionType === "BASE") {
        this.props.selectBaseOption(optionPayload)
      } else {
        this.props.selectAddOn(optionPayload)
      }
  }

  findOption = (options, optionName) => {
    return options.find((option) => {
      return option.name === optionName
    })
  }

  findSize = (optionType, size) => {
    return optionType === 'BASE' ? 12 : size
  }
  
  render() {
    const { classes, options, optionType } = this.props;
    const { expanded } = this.state;
    return(
      <Grid item xs={12} className={classes.root}>
        {options.map((option, index) => (
          <ExpansionPanel 
            expanded={expanded === `${optionType}-${option.name}-${index}`} 
            onChange={this.handleChange(`${optionType}-${option.name}-${index}`)}
            key={`${optionType}-${option.name}-${index}`}
            >
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="body1" className={classes.expansionTitle}>{option.name}</Typography>
            </ExpansionPanelSummary>

            <ExpansionPanelDetails>
            <Grid container>
            { option.description !== "" &&
              <Grid item xs={12} md={8} className={classes.root}>
                <Typography variant="body1">
                  {option.description}
                </Typography>
              </Grid>
              }
              <Grid item xs={12} className={classes.root}>
                { optionType !== 'BASE' &&
                <Typography varient="body2">Select Option:</Typography> 
                }
                <FormControl className={classes.formControl}>
                  <NativeSelect
                      name={option.name}
                      onChange={this.handleSelectChange(options, option.name, optionType)}
                  >
                  <option value="">{ optionType === 'BASE' ? "Select an Option" :  "None" }</option>
                    {option.selections.map((selection, index) => {
                      return (<option 
                                value={index} 
                                key={`${option.name}-${selection.name}-${index}`}>
                                  {selection.name}
                                  {selection.weight ? ` +${selection.weight}g` : ""}
                                  {selection.volume ? ` +${selection.volume}L` : ""}
                                  {selection.cost ? ` +${selection.cost}¥` : ""}
                              </option>)
                    })}
                  </NativeSelect>
                </FormControl>
              </Grid>
            </Grid>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        ))}
      </Grid>
    )
  }
}

export default withStyles(styles)(PackBuilderOptions)